import firebase from "firebase/app";
import "firebase/auth";

firebase.initializeApp(JSON.parse(process.env.FIREBASE_CONFIG));
const auth = firebase.auth();
export { auth };
